import { Box, Typography, useTheme } from "@mui/material";
import handleColors from "../charts/utils/handleColors";
import getColorsForScheme from "./utils/getColorsForScheme";
import { darken } from "@mui/system";
import maskUnits from "../../utils/maskUnits";
import useStyles from "./styles";
import { getColorsArray } from "../../utils/getColorsPallet";
import { useRef } from "react";
import { useEffect } from "react";

const LegendsCharts: React.FC<LegendsChartsProps> = (props) => {
  const {
    keys,
    colorsByKey,
    colors,
    position = "left",
    direction = "row",
    variant = "default",
    legendSpacing = 2,
    units,
    fractionDigits,
    metricsType,
  } = props;
  const theme = useTheme();
  const scheme = colors ? colors?.scheme : "nivo";
  const boxRef = useRef();

  const metricsData = metricsType as MetricResult[];

  //  const numItems = metrics &&Array.isArray(metrics) ? Object.keys(metrics[0]).length : keys?.length || 0;
  const numItems =
    metricsData &&
    metricsData.length > 0 &&
    metricsData[0] &&
    typeof metricsData[0] === "object"
      ? Object.keys(metricsData[0]).length
      : keys?.length || 0;
  const data = keys;
  const legendColors = colors
    ? getColorsArray(numItems, colors, theme.palette.mode === "dark").filter(
        Boolean
      )
    : getColorsForScheme(scheme, numItems);

  const legendStyles = useStyles(theme, metricsData || {});
  const legendColorByKey = (key: string) =>
    colorsByKey ? handleColors(key, theme, colorsByKey) : undefined;
  const unitsCharts = units;
  const fractionDigitsCharts = fractionDigits;

  return (
    <Box
      sx={legendStyles.contentSx(direction, position, legendSpacing)}
      ref={boxRef}
      // paddingX={3}
    >
      {metricsData && metricsData.length > 0
        ? metricsData.map(({ key, label, value }, index) => (
            <Box key={index} sx={legendStyles.contentChildSx(variant)}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  ...(variant === "block" ? { width: "100%" } : {}),
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    alignItems: "center",
                    justifyContent: "start",
                    ...(variant === "block" ? { width: "100%" } : {}),
                  }}
                >
                  <Box
                    sx={[
                      legendStyles.symbolSx(
                        colorsByKey
                          ? legendColorByKey(key)
                          : legendColors[index]
                      ),
                      {
                        border: `1px solid ${
                          colorsByKey
                            ? darken(
                                legendColorByKey(key as string) as string,
                                0.2
                              )
                            : darken(legendColors[index], 0.2)
                        }`,
                      },
                    ]}
                  />
                  <Typography
                    fontSize={{ xs: "clamp(14px, 30cqh, 22px)" }}
                    fontWeight={500}
                    color="text.secondary"
                    sx={variant === "block" ? legendStyles.textTypography : {}}
                    lineHeight={"100%"}
                  >
                    {label ?? key}
                  </Typography>
                </Box>
                <Typography
                  fontSize={
                    variant === "block"
                      ? { xs: "clamp(17px, 40cqh, 24x)" }
                      : { xs: "clamp(17px, 40cqh, 24px)" }
                  }
                  fontWeight={500}
                  color="text.primary"
                  sx={variant === "block" ? legendStyles.textTypography : {}}
                >
                  {variant === "block"
                    ? value
                    : maskUnits(
                        value,
                        units ?? unitsCharts,
                        fractionDigits ?? fractionDigitsCharts
                      )}
                </Typography>
              </Box>
            </Box>
          ))
        : data?.map((item: String, index: number) => {
            return (
              <Box key={index} sx={legendStyles.contentChildSx(variant)}>
                <Box
                  sx={[
                    legendStyles.symbolSx(
                      colorsByKey
                        ? legendColorByKey(item as string)
                        : legendColors[index]
                    ),
                    {
                      border: `1px solid ${
                        colorsByKey
                          ? darken(
                              legendColorByKey(item as string) as string,
                              0.2
                            )
                          : darken(legendColors[index] || "#000", 0.2)
                      }`,
                    },
                  ]}
                />
                <Typography sx={legendStyles.textSx}>{String(item)}</Typography>
              </Box>
            );
          })}
    </Box>
  );
};

export default LegendsCharts;
